/* 针对本次提供的 Shrine 主题代码 */
(() => {
  'use strict';

  // 防止重复加载。
  if (window.__cartUpsellHotfixV1) return;
  window.__cartUpsellHotfixV1 = true;

  function restoreAddRoute() {
    if (window.routes && window.routes.cart_add_url === 'cart') {
      window.routes.cart_add_url =
        (window.Shopify?.routes?.root || '/') + 'cart/add.js';
    }
  }

  // 修复数量变化/删除商品后提前退出、不刷新购物车的问题。
  ['cart-items', 'cart-drawer-items'].forEach((tag) => {
    customElements.whenDefined(tag).then(() => {
      const proto = customElements.get(tag).prototype;
      const original = proto.updateQuantity;

      if (typeof original !== 'function') return;

      if (!original.__cartUpsellHotfixV1) {
        const wrapped = function (...args) {
          this.lineItemContainer = true;
          restoreAddRoute();
          return original.apply(this, args);
        };

        wrapped.__cartUpsellHotfixV1 = true;
        proto.updateQuantity = wrapped;
      }

      document.querySelectorAll(tag).forEach((el) => {
        el.lineItemContainer = true;
      });

      restoreAddRoute();
    });
  });

  // 在原主题生成 FormData 时同步修改本次请求。
  // 不另发加购请求，不修改套餐使用的 ref 状态。
  document.addEventListener('formdata', (event) => {
    restoreAddRoute();

    const form = event.target;
    const owner = form.closest?.('product-form.main-product-form');

    if (!owner || owner.form !== form || owner.skipCart) return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // 主商品表单不应该被识别为购物车 upsell 表单。
    owner.isCartUpsell = false;

    const fd = event.formData;
    const mainId = String(
      owner.formIdInput?.value || fd.get('id') || ''
    );

    const toggles = new Map();

    drawer
      .querySelectorAll('cart-drawer-upsell[data-toggle="true"]')
      .forEach((el) => {
        const id = el.dataset.id;

        // 不把当前主商品当作附加保险处理。
        if (id && id !== mainId) toggles.set(id, el);
      });

    if (!toggles.size) return;

    // 保留原主题已经生成的套餐、赠品和商品属性。
    const entries = Array.from(fd.entries());
    const groups = new Map();

    entries.forEach(([key, value]) => {
      const match = key.match(/^items\[(\d+)\](\[.*\])$/);
      if (!match) return;

      if (!groups.has(match[1])) groups.set(match[1], []);
      groups.get(match[1]).push([match[2], value]);
    });

    let items = Array.from(groups.values());

    // 普通单商品表单转为多商品格式。
    if (!items.length) {
      if (!fd.get('id')) return;

      const main = [
        ['[id]', fd.get('id')],
        ['[quantity]', fd.get('quantity') || '1']
      ];

      entries.forEach(([key, value]) => {
        if (key === 'selling_plan' && value) {
          main.push(['[selling_plan]', value]);
        } else if (/^properties\[.*\]$/.test(key)) {
          main.push(['[properties]' + key.slice(10), value]);
        }
      });

      items = [main];
    }

    const itemId = (item) => String(
      item.find(([key]) => key === '[id]')?.[1] || ''
    );

    const originalItems = items;

    // 清除表单中残留的 upsell 项，再按照当前开关状态补入。
    items = items.filter((item) => !toggles.has(itemId(item)));

    toggles.forEach((el, id) => {
      const handle = el.dataset.handle;

      // 隐藏的购物车商品行也可以用于判断商品是否已经存在。
      const inCart = handle && drawer.querySelector(
        '.cart-item--product-' + CSS.escape(handle)
      );

      // 未勾选，或者已经在购物车里，都不再次追加。
      if (el.dataset.selected !== 'true' || inCart) return;

      const existing = originalItems.find(
        (item) => itemId(item) === id
      );

      const item = existing
        ? existing.filter(([key]) => key !== '[quantity]')
        : [['[id]', id]];

      // 保持原主题的附加商品数量规则：一次加入一份。
      item.push(['[quantity]', '1']);

      const plan = el.querySelector(
        'input[name="selling_plan"]'
      )?.value;

      if (plan && !item.some(([key]) => key === '[selling_plan]')) {
        item.push(['[selling_plan]', plan]);
      }

      items.push(item);
    });

    if (!items.length) return;

    // 重建本次请求的 items，避免同时发送单商品和多商品字段。
    entries.forEach(([key]) => {
      if (
        /^items\[\d+\]/.test(key) ||
        ['id', 'quantity', 'selling_plan'].includes(key) ||
        /^properties\[/.test(key)
      ) {
        fd.delete(key);
      }
    });

    items.forEach((item, index) => {
      item.forEach(([suffix, value]) => {
        fd.append('items[' + index + ']' + suffix, value);
      });
    });
  }, true);

  restoreAddRoute();
})();